import useOnValueChange from "../../../hooks/useOnValueChange";
import { InputProps } from "../Calculator";
import NumberInput from "../../BuildingBlocks/NumberInput/NumberInput";

const TITLE = "דמי ניהול מהצבירה";
const SUBTITLE = "אחוז דמי ניהול מהצבירה השנתית";
const NAME = "accumulation-fees";

const AccumulationFeesInput = ({ contextKey }: InputProps) => {
  const onValueChange = useOnValueChange(contextKey);

  return (
    <NumberInput
      title={TITLE}
      placeholder={SUBTITLE}
      name={NAME}
      onlyPositive
      isRate={true}
      onChange={(value: number) => onValueChange(value)}
    />
  );
};

export default AccumulationFeesInput;
